import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { ErrorAlert } from './ErrorAlert';
import { InformationAlert } from './InformationAlert';
import { SuccessAlert } from './SuccessAlert';

export { ErrorCard } from './ErrorCard';

interface AlertProps {
  type: 'error' | 'success' | 'info';
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  children?: ReactNode;
  buttonText?: string;
  buttonClassName?: string;
}

export function Alert({
  type,
  show,
  setShow,
  ...props
}: AlertProps): ReactNode {
  switch (type) {
    case 'error':
      return <ErrorAlert show={show} setShow={setShow} {...props} />;
    case 'success':
      return <SuccessAlert show={show} setShow={setShow} {...props} />;
    case 'info':
      return <InformationAlert show={show} setShow={setShow} {...props} />;
    default:
      return null;
  }
}
